/**
 * Filters used for audit timeline requests.
 */
export class AuditFilter {
    userId: number;
    workflowType: string;
    userRole: string;
    startDate: Date | string;
    endDate: Date | string;
    searchText: string;
    eventTypes: string[];
    sortOrder: 'desc' | 'asc';
}

export interface AuditEventTypeOption {
    id: string;
    label: string;
    icon: string;
}

export const AUDIT_EVENT_TYPES: AuditEventTypeOption[] = [
    { id: 'TASK', label: 'Tasks', icon: 'assignment_turned_in' },
    { id: 'MANUAL', label: 'Manual notes', icon: 'note_add' },
    { id: 'DOCUMENT', label: 'Documents', icon: 'description' },
    { id: 'ADDRESS', label: 'Addresses', icon: 'location_on' },
    { id: 'RELATION', label: 'Relations', icon: 'people' },
    { id: 'COMMUNICATION', label: 'Communications', icon: 'email' },
    { id: 'COMMENT', label: 'Comments', icon: 'comment' },
    { id: 'TRANSACTION_RULE', label: 'Transactions', icon: 'swap_horiz' },
];

export interface AuditDatePreset {
    id: string;
    label: string;
    days?: number;
}

export const AUDIT_DATE_PRESETS: AuditDatePreset[] = [
    { id: 'all', label: 'All time' },
    { id: '7d', label: 'Last 7 days', days: 7 },
    { id: '30d', label: 'Last 30 days', days: 30 },
    { id: '365d', label: 'Last year', days: 365 },
];

export interface ActiveAuditFilter {
    key: string;
    label: string;
}



// WEBPACK FOOTER //
// ./src/app/entities/audit/audit-filter.model.ts